import createCollectionStore from '../create';
import { fetchAll, updateUser, createUser, changeUserPassword } from '../../core-data';
import { User } from '../../core-data/types';
import UUID from 'uuid';

export default createCollectionStore(
  'User',
  false,
  () => fetchAll(User),
  'uuid',
  [],
  {
    create: async (state, actions, user, password) => {
      const modified = {
        uuid: UUID.v4(),
        ...user
      };
      await createUser(user, password);
      await actions.updateCache(modified);
      return {};
    },
    update: async (state, actions, user) => {
      const modified = {
        uuid: UUID.v4(),
        ...user
      };
      await updateUser(modified);
      await actions.updateCache(modified);
      return {};
    },
    updatePassword: async (state, actions, user) => {

    }
  }
);



// WEBPACK FOOTER //
// ./src/services/collection/collections/user.js